module.exports = __webpack_public_path__ + "static/media/AWSSAA3.5637ebfe.png";